export class OfferComissionFull {

  commission_description: string;

  constructor() {
    this.commission_description = '';
  }
}
